import Logger from "@cappelendamm/logger";
import { CustomerSchema, CustomerBackofficeSchema, } from "../schemas/customer-schema.js";
export const getValidatedCustomer = (customer) => {
    try {
        return CustomerSchema.parse(customer);
    }
    catch (error) {
        Logger.error(`Failed to validate customer with identifier: ${customer.identifier}. Error: ${error}`);
        return undefined;
    }
};
export const getValidatedCustomerBackoffice = (customer) => {
    try {
        return CustomerBackofficeSchema.parse(customer);
    }
    catch (error) {
        Logger.error(`Failed to validate customer with identifier: ${customer.identifier}. Error: ${error}`);
        return undefined;
    }
};
